"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSuccessInterceptor = void 0;
const requestSuccessInterceptor = (config, authStorage) => {
    if (authStorage.accessToken) {
        config.headers.Authorization = `Bearer ${authStorage.accessToken}`;
        config.withCredentials = true;
        return config;
    }
    return config;
};
exports.requestSuccessInterceptor = requestSuccessInterceptor;
